import React, { forwardRef } from 'react';
import { useSurveyFormatContext } from '../useSurveyFormatContext';
import { SurveyFormatViewProps } from '../types';

import useFormatView from './useFormatView';
import { isChildFunction } from '../utils';

export function ClassicFormatView(
  { name, noShield, className, autoPadding, children, ...props }: SurveyFormatViewProps,
  forwardedRef?: React.Ref<HTMLDivElement>
): React.ReactElement {
  const formatContext = useSurveyFormatContext();
  const { ref } = useFormatView<HTMLDivElement>(name, formatContext, null, forwardedRef);
  const content = isChildFunction(children) ? children(true, () => {}) : children;

  return (
    <div className={className} {...props} ref={ref}>
      {content}
    </div>
  );
}

export default forwardRef<HTMLDivElement, SurveyFormatViewProps>(ClassicFormatView);
